/**
 * 密碼規則（v2.32.0）
 *
 * 前端有**兩個**地方要改密碼：
 *   1. `views/MainLayout/ForcePasswordChange.js` —— 首次登入強制修改（整頁）
 *   2. `components/ChangePasswordModal.js`       —— 右上角選單，隨時改（Modal）
 *
 * 規則抽在這裡，因為這個 repo 已經被「同一件事有兩份實作」咬過好幾次
 * （getWeekExpenses 表格與圖表各一份、CashflowEditCell 兩個頁面各一份、
 * 下載檔案三個檔各一份），每次都是「要改的時候才發現要改兩個地方」。
 *
 * ⚠️ `MIN_LENGTH` 必須與後端 `auth_service.MIN_PASSWORD_LENGTH` 一致。
 *    這裡只是提早提示，**真正的把關在後端**。
 */
export const MIN_LENGTH = 10;

/**
 * 檢查新密碼。回錯誤訊息字串，或 null 表示沒問題。
 * @param {string} oldPassword 目前密碼
 * @param {string} newPassword 新密碼
 * @param {string} confirm     再輸入一次
 */
export function validateNewPassword(oldPassword, newPassword, confirm) {
  if (!oldPassword) return "請輸入目前的密碼";
  if (!newPassword) return "請輸入新密碼";
  if (newPassword.length < MIN_LENGTH) return `新密碼至少要 ${MIN_LENGTH} 個字元`;
  if (newPassword === oldPassword) return "新密碼不能和目前的密碼相同";
  if (confirm !== newPassword) return "兩次輸入的新密碼不一致";
  return null;
}
